var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container bg-white"},[_c('div',{staticClass:"m-xxl"},[_c('H2',{attrs:{"font-family":"Bitter","center":""}},[_vm._v(_vm._s(_vm.$t('configurator.thankYou')))]),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('configurator.thankYouText')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }